import groq from "groq";
import { Insight, insightFields } from "../types/insight";
import { LearningArticle } from "../types/learningArticle";
import { excludeDraftsFilter } from "../queries/filters";
import { getSuggestedArticlesQuery } from "../queries/suggestedArticlesQuery";
import { cmsQuery, CMSResult } from "./cmsClient";
import { QueryableSanityData } from "../types/sanity";
import { Ok } from "@pairtreefamily/utils";
import { getSingleDocumentData } from "../utils/getSingleDocumentData";
import { HeaderNavigationProps } from "@/components/HeaderNavigation";

export type InsightArticleData = Insight & {
  suggestedArticles: LearningArticle[];
};

export type GetInsightArticleQueryArgs = {
  preview?: boolean;
};

export type GetInsightArticleQueryParams = {
  slug: string;
};

export function getInsightArticleQuery({
  preview,
}: GetInsightArticleQueryArgs): string {
  return groq`
    *[_type == "insight"
      && slug.current == $slug 
      ${!preview ? `&& ${excludeDraftsFilter}` : ""}]
    {
      ${insightFields},
      "suggestedArticles": ${getSuggestedArticlesQuery({ preview })}
    }
  `;
}

export type GetInsightArticleArgs = {
  slug: string;
  preview?: boolean;
};

export async function getInsightArticle(
  args: GetInsightArticleArgs,
): Promise<CMSResult<QueryableSanityData<InsightArticleData>>> {
  const { slug, preview } = args;
  const query = getInsightArticleQuery({ preview });
  const queryParams: GetInsightArticleQueryParams = {
    slug,
  };

  const insightArticleResult = await cmsQuery<InsightArticleData>({
    query,
    queryParams,
    preview,
  });

  const insightArticleData = getSingleDocumentData(
    insightArticleResult,
    preview,
  );

  if (!insightArticleData.ok) {
    return insightArticleData;
  }

  return Ok({
    query,
    queryParams,
    data: insightArticleData.content,
  });
}

export const insightArticleSlugsQuery = groq`
  *[_type == "insight" && defined(slug.current)].slug.current
`;

export function getInsightArticleSlugs(): Promise<CMSResult<string[]>> {
  const query = insightArticleSlugsQuery;
  return cmsQuery<string[]>({
    query,
  });
}
